<div class="flex justify-between pl-4 mb-4">
  <h1>Wholesalers</h1>
  <!--<lib-button [cssType]="'btn-primary'" [icon]="'rightarrow'"  [text]="'Add Wholesaler'" [size]="'large'" (click)="addWholesaler()"></lib-button>-->
</div>
<lib-ui-grid class="mt-4" [(gridOptions)]="gridOptions" (actionEvent)="actionEvent($event)"></lib-ui-grid>